/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'headerIcons/career': {
    width: 22,
    height: 20,
    viewBox: '0 0 22 20',
    data: '<path pid="0" d="M19.8 4.21h-4.4V2.106C15.4.937 14.421 0 13.2 0H8.8C7.579 0 6.6.937 6.6 2.105v2.106H2.2C.979 4.21.011 5.147.011 6.316L0 17.895C0 19.063.979 20 2.2 20h17.6c1.221 0 2.2-.937 2.2-2.105V6.315c0-1.168-.979-2.104-2.2-2.104zm-6.6 0H8.8V2.106h4.4v2.106z" _fill="#000" fill-rule="nonzero"/>'
  }
})
